import { Grid } from "@mui/material";
import React from "react";
import IssuedCardHeader from "./home/header";
import IssuedCardTabel from "./home/table";

const IssuedCard = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <IssuedCardHeader />
      </Grid>
      <Grid item xs={12}>
        <IssuedCardTabel />
      </Grid>
    </Grid>
  );
};

export default IssuedCard;
